import React, { FC } from "react";

import Table, { TableBody, TableHeader } from "../../../components/Table";
import { columns } from "./constants";
import { PrincipalDBTableProps } from "./types";

import "./styles.scss";

export const PrincipalDBTable: FC<PrincipalDBTableProps> = ({
  data,
  defaultSort,
  onSort,
  onDoubleClick,
}) => {
  return (
    <>
      <div>
        <Table className="ams-principal-database">
          <TableHeader
            columns={columns}
            defaultSort={defaultSort}
            onSort={onSort}
          />
          <TableBody
            columns={columns}
            data={data}
            onDoubleClick={onDoubleClick}
          />
        </Table>
      </div>
    </>
  );
};
